program WzWebPortal;

{$R *.dres}

uses
  Vcl.Forms,
  WEBLib.Forms,
  UAppForLeaveConfig in '..\Client\Configurations\UAppForLeaveConfig.pas',
  UClockInConfig in '..\Client\Configurations\UClockInConfig.pas',
  UColorConfig in '..\Client\Configurations\UColorConfig.pas',
  UCommonConfig in '..\Client\Configurations\UCommonConfig.pas',
  UMainConfig in '..\Client\Configurations\UMainConfig.pas',
  UMenuConfig in '..\Client\Configurations\UMenuConfig.pas',
  UOverviewConfig in '..\Client\Configurations\UOverviewConfig.pas',
  UTimeDataConfig in '..\Client\Configurations\UTimeDataConfig.pas',
  UAbwHelper in '..\Client\Helpers\UAbwHelper.pas',
  UEssentialHelper in '..\Client\Helpers\UEssentialHelper.pas',
  UTimeDataHelper in '..\Client\Helpers\UTimeDataHelper.pas',
  UMenuForm in '..\Client\Forms\UMenuForm.pas'{*.html},
  UPersonalDataForm in '..\Client\Forms\UPersonalDataForm.pas'{*.html},
  UTimeDataForm in '..\Client\Forms\UTimeDataForm.pas'{*.html},
  UMainForm in 'UMainForm.pas'{*.html},
  UWebSpeechRec in '..\Client\Miscs\UWebSpeechRec.pas',
  UGridHelper in '..\Client\Helpers\UGridHelper.pas',
  UWebBarcodeScanner in '..\Client\Miscs\UWebBarcodeScanner.pas',
  UWebHtml2Pdf in '..\Client\Miscs\UWebHtml2Pdf.pas',
  UBarcodeScannerConfig in '..\Client\Configurations\UBarcodeScannerConfig.pas',
  UWebReportUtils in '..\Client\Miscs\UWebReportUtils.pas',
  UReportListForm in '..\Client\Forms\UReportListForm.pas'{*.html},
  UReportShowForm in '..\Client\Forms\UReportShowForm.pas'{*.html},
  UReportForm in '..\Client\Forms\UReportForm.pas'{*.html},
  UReportItemForm in '..\Client\Forms\UReportItemForm.pas'{*.html},
  UMaterialListForm in '..\Client\Forms\UMaterialListForm.pas'{*.html},
  UMenu1Form in '..\Client\Forms\UMenu1Form.pas'{*.html},
  UAbwForm in '..\Client\Forms\UAbwForm.pas',
  UAttachmentListForm in '..\Client\Forms\UAttachmentListForm.pas',
  UBarcodeScannerForm in '..\Client\Forms\UBarcodeScannerForm.pas',
  UCameraForm in '..\Client\Forms\UCameraForm.pas'{*.html},
  UClockEditForm in '..\Client\Forms\UClockEditForm.pas',
  UClockInForm in '..\Client\Forms\UClockInForm.pas',
  UCommentForm in '..\Client\Forms\UCommentForm.pas'{*.html},
  UEditPasswordForm in '..\Client\Forms\UEditPasswordForm.pas',
  UEditRemoteUserForm in '..\Client\Forms\UEditRemoteUserForm.pas',
  UFakForm in '..\Client\Forms\UFakForm.pas'{*.html},
  UHolidayCancelForm in '..\Client\Forms\UHolidayCancelForm.pas',
  UHolidayDetailForm in '..\Client\Forms\UHolidayDetailForm.pas',
  UHolidayForm in '..\Client\Forms\UHolidayForm.pas',
  UHolidayNewForm in '..\Client\Forms\UHolidayNewForm.pas',
  UImageShowForm in '..\Client\Forms\UImageShowForm.pas'{*.html},
  ULoginForm in '..\Client\Forms\ULoginForm.pas',
  UTaetForm in '..\Client\Forms\UTaetForm.pas'{*.html},
  UVmPosForm in '..\Client\Forms\UVmPosForm.pas'{*.html},
  UAbwList in '..\Client\Lists\UAbwList.pas',
  UAttachmentList in '..\Client\Lists\UAttachmentList.pas',
  UColumnList in '..\Client\Lists\UColumnList.pas',
  UContentList in '..\Client\Lists\UContentList.pas',
  UFakList in '..\Client\Lists\UFakList.pas',
  UFeiertagList in '..\Client\Lists\UFeiertagList.pas',
  UHistoryList in '..\Client\Lists\UHistoryList.pas',
  UHolidayList in '..\Client\Lists\UHolidayList.pas',
  UInstanceList in '..\Client\Lists\UInstanceList.pas',
  UKstList in '..\Client\Lists\UKstList.pas',
  UMatList in '..\Client\Lists\UMatList.pas',
  UStampList in '..\Client\Lists\UStampList.pas',
  UTaetList in '..\Client\Lists\UTaetList.pas',
  UTagKzList in '..\Client\Lists\UTagKzList.pas',
  UTransferList in '..\Client\Lists\UTransferList.pas',
  UVmPosList in '..\Client\Lists\UVmPosList.pas',
  UWaitingList in '..\Client\Lists\UWaitingList.pas',
  UZeitartList in '..\Client\Lists\UZeitartList.pas',
  UZrValueList in '..\Client\Lists\UZrValueList.pas',
  UAbwModel in '..\Client\Models\UAbwModel.pas',
  UAttachmentModel in '..\Client\Models\UAttachmentModel.pas',
  UColumnModel in '..\Client\Models\UColumnModel.pas',
  UFakModel in '..\Client\Models\UFakModel.pas',
  UFakParaModel in '..\Client\Models\UFakParaModel.pas',
  UFeiertagModel in '..\Client\Models\UFeiertagModel.pas',
  UHistoryModel in '..\Client\Models\UHistoryModel.pas',
  UHolidayModel in '..\Client\Models\UHolidayModel.pas',
  UInstanceModel in '..\Client\Models\UInstanceModel.pas',
  UKstModel in '..\Client\Models\UKstModel.pas',
  UMatModel in '..\Client\Models\UMatModel.pas',
  UPictureModel in '..\Client\Models\UPictureModel.pas',
  UResultModel in '..\Client\Models\UResultModel.pas',
  UStampModel in '..\Client\Models\UStampModel.pas',
  UTaetModel in '..\Client\Models\UTaetModel.pas',
  UTagKzModel in '..\Client\Models\UTagKzModel.pas',
  UTransferModel in '..\Client\Models\UTransferModel.pas',
  UUserModel in '..\Client\Models\UUserModel.pas',
  UValueModel in '..\Client\Models\UValueModel.pas',
  UVmPosModel in '..\Client\Models\UVmPosModel.pas',
  UWaitingModel in '..\Client\Models\UWaitingModel.pas',
  UZeitartModel in '..\Client\Models\UZeitartModel.pas',
  UZrValueModel in '..\Client\Models\UZrValueModel.pas';

{$R *.res}

begin
  Application.Initialize;
  Application.MainFormOnTaskbar := True;
  Application.CreateForm(TMainForm, MainForm);
  Application.CreateForm(TAbwForm, AbwForm);
  Application.CreateForm(TClockInForm, ClockInForm);
  Application.CreateForm(TEditPasswordForm, EditPasswordForm);
  Application.CreateForm(TEditRemoteUserForm, EditRemoteUserForm);
  Application.CreateForm(THolidayCancelForm, HolidayCancelForm);
  Application.CreateForm(THolidayDetailForm, HolidayDetailForm);
  Application.CreateForm(THolidayForm, HolidayForm);
  Application.CreateForm(THolidayNewForm, HolidayNewForm);
  Application.CreateForm(TLoginForm, LoginForm);
  Application.CreateForm(TMenuForm, MenuForm);
  Application.CreateForm(TPersonalDataForm, PersonalDataForm);
  Application.CreateForm(TTimeDataForm, TimeDataForm);
  Application.CreateForm(TMainForm, MainForm);
  Application.CreateForm(TClockEditForm, ClockEditForm);
  Application.CreateForm(TAttachmentListForm, AttachmentListForm);
  Application.CreateForm(TReportListForm, ReportListForm);
  Application.CreateForm(TReportShowForm, ReportShowForm);
  Application.CreateForm(TReportForm, ReportForm);
  Application.CreateForm(TReportItemForm, ReportItemForm);
  Application.CreateForm(TMaterialListForm, MaterialListForm);
  Application.CreateForm(TBarcodeScannerForm, BarcodeScannerForm);
  Application.CreateForm(TMenu1Form, Menu1Form);
  Application.CreateForm(TAbwForm, AbwForm);
  Application.CreateForm(TAttachmentListForm, AttachmentListForm);
  Application.CreateForm(TBarcodeScannerForm, BarcodeScannerForm);
  Application.CreateForm(TCameraForm, CameraForm);
  Application.CreateForm(TClockEditForm, ClockEditForm);
  Application.CreateForm(TClockInForm, ClockInForm);
  Application.CreateForm(TCommentForm, CommentForm);
  Application.CreateForm(TEditPasswordForm, EditPasswordForm);
  Application.CreateForm(TEditRemoteUserForm, EditRemoteUserForm);
  Application.CreateForm(TFakForm, FakForm);
  Application.CreateForm(THolidayCancelForm, HolidayCancelForm);
  Application.CreateForm(THolidayDetailForm, HolidayDetailForm);
  Application.CreateForm(THolidayForm, HolidayForm);
  Application.CreateForm(THolidayNewForm, HolidayNewForm);
  Application.CreateForm(TImageShowForm, ImageShowForm);
  Application.CreateForm(TLoginForm, LoginForm);
  Application.CreateForm(TTaetForm, TaetForm);
  Application.CreateForm(TVmPosForm, VmPosForm);
  Application.Run;
end.
